import { Component, inject, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AccountService, AuthService } from '@fgb/core';
import { lastValueFrom } from 'rxjs';

@Component({
  selector: 'fgb-account-verified-page',
  templateUrl: './account-verified-page.component.html',
  styleUrl: './account-verified-page.component.scss',
})
export class AccountVerifiedPageComponent implements OnInit {
  @Input() code: string = '';
  private accountService = inject(AccountService);
  private authService = inject(AuthService);
  private router = inject(Router);
  isError: boolean = false;
  isLoaded: boolean = false;

  ngOnInit(): void {
    this.accountService.verify(this.code).subscribe({
      next: (response) => {},
      error: (error) => {
        this.isError = true;
        this.isLoaded = true;
      },
      complete: () => {
        this.isLoaded = true;
      },
    });
  }

  back(): void {
    lastValueFrom(this.authService.logout()).then(() => {
      this.router.navigate(['/login']);
    });
  }
}
